export default __webpack_public_path__ + "static/media/FISIOLOGICIICONA.6311e630.svg";